// 右上角遊戲標題「小紅帽」金框 Logo（沿用 Unity Art/Game/zh-Hant/logo.png）。
// 照 Unity LandscapeUI.prefab 的 Logo（GameFrontCanvas 下）：aPos (819.6, 460.8)、原尺寸 277×188、
// scale 1.16；直版照 PoriraitUI.prefab 覆寫：aPos (−1.6, 867.6)、scale 1.29（頂部中央）。
// 主遊戲/免費遊戲恆顯示。

import { Container, Sprite } from 'pixi.js'
import {
  unityAnchorLandscape,
  unityAnchorPortrait,
  unityScaleLandscape,
  unityScalePortrait,
  type Orientation,
  type Resizable,
} from '../../../framework/render/design'
import { getUiTexture } from '../../assets/UiTextures'

/** Unity Logo 版面常數（橫版 LandscapeUI／直版 PoriraitUI 覆寫）。 */
const LOGO_AX = 819.6
const LOGO_AY = 460.8
const LOGO_SCALE = 1.16
const LOGO_P_AX = -1.6
const LOGO_P_AY = 867.6
const LOGO_P_SCALE = 1.29

export class LogoView extends Container implements Resizable {
  private readonly sprite = new Sprite(getUiTexture('logo'))

  constructor() {
    super()
    this.sprite.anchor.set(0.5)
    this.addChild(this.sprite)
  }

  resize(width: number, height: number, orientation: Orientation): void {
    if (orientation === 'portrait') {
      const s = unityScalePortrait(width, height)
      const center = unityAnchorPortrait(LOGO_P_AX, LOGO_P_AY, width, height)
      this.sprite.scale.set(s * LOGO_P_SCALE)
      this.sprite.position.set(center.x, center.y)
      return
    }
    const s = unityScaleLandscape(width, height)
    const center = unityAnchorLandscape(LOGO_AX, LOGO_AY, width, height)
    this.sprite.scale.set(s * LOGO_SCALE)
    this.sprite.position.set(center.x, center.y)
  }
}
